<template>
  <va-create-layout>
    <contacts-form :title="title" :item="item"></contacts-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
